export function formatDate(value) {
  if (!value) return "";
  return new Intl.DateTimeFormat("es-ES", { day: "numeric", month: "short", year: "numeric" })
    .format(new Date(value));
}

export function initials(user) {
  return String(user?.displayName || user?.username || "R").trim().slice(0, 1).toUpperCase();
}

export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export function profilePath(username) {
  return `/perfil/${encodeURIComponent(username)}`;
}
